"use strict";

import { onAuthStateChanged } from "firebase/auth";
import {
  confirmLoginModal,
  formatDate,
  formatTime,
  getMapLink,
  getPlayerPos,
  initFooter,
  initLangAction,
  initLangCookie,
  list_event,
  list_msg,
  list_person,
  list_player,
  list_rsvp,
  setDisplay,
  shake,
  showConfirmModal,
  showToast,
} from "./common";
import { db, initAuth } from "./config";
import {
  child,
  off,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  onValue,
  push,
  ref,
  remove,
  set,
} from "firebase/database";
import phGroup from "url:../images/group.svg";
import phUser from "url:../images/user.svg";
import phImg from "../images/img.svg";

let lang;
let group, teamId;
let groupId;
let tabs;
let frags;
let ivIcon, dName, dDesc;
let user, userInfo, role;
let dEventList, dPlayerList, dRsvpPlayerList;
let dStaffList, dMemberList;
let dNoPeople;
let playerKeyList = [];
let dbUser, dbRole;
let dbGroup;
let dbEvents, dbTeam, dbChat, dbMsg, dbUchat;
let dbPlayers, dbPlayer, dbStaff, dbMembers, dbJoined;
let dbPRsvp, dbPlayerGoingCount;
let currentPerson = 0;
let dGroup404, dLoadingModal, dRsvp;
let dbUserGoingCount, dbURsvp;
let activeEvent;
let dMsgList, dEmptyMsg;
let btnSendMsg, inMsg;

$(document).ready(function () {
  $(function () {
    initFooter();
    initLangUi();
    initUi();
    getUser();
  });
});

function initLangUi() {
  lang = initLangCookie();
  initLangAction();
}

function initUi() {
  ivIcon = document.getElementById("ivIcon");
  dName = document.getElementById("gName");
  dDesc = document.getElementById("gDesc");
  tabs = document.getElementById("tabs").querySelectorAll("div");
  frags = document.querySelectorAll(".g-frag");
  dEventList = document.getElementById("dEventList");
  dPlayerList = document.getElementById("dPlayerList");
  dRsvpPlayerList = document.getElementById("dRsvpPlayers");
  dGroup404 = document.getElementById("dGroup404");
  dLoadingModal = document.getElementById("dLoadingModal");
  dRsvp = document.getElementById("dRsvp");
  dStaffList = document.getElementById("dStaffList");
  dMemberList = document.getElementById("dMemberList");
  dMsgList = document.querySelector("#dChat .msg-list");
  dEmptyMsg = document.querySelector("#dChat .empty");
}

function getUser() {
  setDisplay(dLoadingModal, "flex");
  let auth = initAuth;
  let startLs = true;
  onAuthStateChanged(auth, (data) => {
    user = data;
    if (user) {
      getUserInfo();
    }
    if (startLs) {
      startLs = false;
      initLs();
    }
  });
}
function getUserInfo() {
  dbUser = ref(db, `user/${user.uid}`);
  onValue(
    dbUser,
    (data) => {
      if (data.exists()) {
        userInfo = data.val();
      } else {
        userInfo = null;
      }
      initRsvpUi();
    },
    { onlyOnce: true }
  );
}
function initRsvpUi() {
  let rsvpUser = dRsvp.querySelector("#dRsvpStaff .rsvp");
  let imgUser = rsvpUser.querySelector("img");
  let dName = rsvpUser.querySelector(".name");

  $(imgUser).on("error", function () {
    imgUser.src = phUser;
  });

  if (userInfo) {
    imgUser.src = userInfo.imgUrl ? userInfo.imgUrl : phUser;
    dName.textContent = `${userInfo.name} (You)`;
  } else {
    setDisplay(rsvpUser, "none");
  }
}

function initLs() {
  let search = window.location.search.replace("?", "").replaceAll("+", " ");
  let url = decodeURIComponent(window.location.href);
  if (url.indexOf("group/") > -1) {
    let groupName = url
      .substring(url.lastIndexOf("/") + 1)
      .replaceAll("+", " ");
    findGroup(groupName);
  } else if (search) {
    findGroup(search);
  } else {
    //TODO: search for groups modal
  }

  dRsvp.querySelector(".btn-close").addEventListener("click", function (event) {
    setDisplay(dRsvp, "none");
    resetRsvpLs();
  });
}
function resetRsvpLs() {
  activeEvent = null;
  if (dbURsvp) {
    off(dbURsvp);
  }

  if (dbUserGoingCount) {
    off(dbUserGoingCount);
  }

  if (dbPRsvp) {
    for (let index = 0; index < playerKeyList.length; index++) {
      const playerId = playerKeyList[index];
      off(child(dbPRsvp, `${playerId}`));
    }
  }

  if (dbPlayerGoingCount) {
    off(dbPlayerGoingCount);
  }
}
function findGroup(name) {
  let dbSearch = ref(db, `gLink/${name}`);

  onValue(
    dbSearch,
    (data) => {
      if (data.exists()) {
        groupId = data.val();
        if (groupId != null) {
          initRoleLs();
        } else {
          setDisplay(dGroup404, "flex");
        }
      } else {
        groupId = null;
        setDisplay(dGroup404, "flex");
      }
    },
    { onlyOnce: true }
  );
}

function initRoleLs() {
  let btnEdit = dRsvp.querySelector(".btn-rs-edit");
  if (user) {
    dbRole = ref(db, `role/${groupId}/${user.uid}`);
    onValue(dbRole, (data) => {
      if (data.exists()) {
        role = data.val();
      } else {
        setDefRole();
      }
      setDisplay(btnEdit, role.owner || role.staff ? "block" : "none");
      initGroupLs();
    });
  } else {
    setDefRole();
    setDisplay(btnEdit, "none");
    initGroupLs();
  }
}
function initGroupLs() {
  let startfrags = true;
  dbGroup = ref(db, `group/${groupId}`);
  onValue(dbGroup, (data) => {
    setDisplay(dLoadingModal, "none");
    if (data.exists()) {
      group = data.val();
      if (group != null) {
        updateGroupUi();
        if (startfrags) {
          startfrags = false;
          initFrags();
        }
      } else {
        setDisplay(dGroup404, "flex");
      }
    } else {
      setDisplay(dGroup404, "flex");
    }
  });
}

function setDefRole() {
  role = {
    admin: false,
    coach: false,
    member: false,
    owner: false,
    staff: false,
  };
}
function updateGroupUi() {
  $(ivIcon).on("error", function () {
    ivIcon.src = phGroup;
  });
  ivIcon.src = group.imgUrl ? group.imgUrl : phGroup;
  dName.textContent = group.name;
  dDesc.textContent = group.desc;
}
function initFrags() {
  let current = 0;
  initEventFrag();
  for (let index = 0; index < tabs.length; index++) {
    const tab = tabs[index];
    $(tab).click(function () {
      if (index == 2 && (!user || !role.member)) {
        //is chat
        if (!user) {
          confirmLoginModal(
            "Register or login to participate in the chat",
            `?g=${group.name}`
          );
        } else {
          showConfirmModal(
            "Join group",
            "You are not a part of this group yet. Would you like to join this group?",
            joinGroup
          );
        }
        return;
      }
      tabs[current].classList.remove("selected");
      setDisplay(frags[current], "none");

      setDisplay(frags[index], "flex");
      tabs[index].classList.add("selected");
      current = index;
      initFragLs(index);
    });
  }
}

function initFragLs(index) {
  switch (index) {
    case 0:
      if (dbEvents == null) {
        initEventFrag();
      }
      break;
    case 1:
      if (dbTeam == null) {
        initTeamFrag();
      }
      break;
    default: //chat 2
      initChatFrag();
      break;
  }
}

function initEventFrag() {
  dbEvents = ref(db, `event/${groupId}`);
  let dNone = document.querySelector("#dEvents .dNone");

  onChildAdded(dbEvents, (data) => {
    setDisplay(dNone, "none");
    addEvent(dEventList, data.key, data.val());
  });

  onChildChanged(dbEvents, (data) => {
    addEvent(dEventList, data.key, data.val());
  });
  onChildRemoved(dbEvents, (data) => {
    removeElement(data.key);
    if (dEventList.children.length == 0) {
      setDisplay(dNone, "flex");
    }
  });
}
function removeElement(id) {
  let e = document.getElementById(id);
  if (e) {
    e.remove();
  }
}
function addEvent(parent, key, event) {
  var dOld = document.getElementById(key);
  const container = document.createElement("div");
  container.innerHTML = list_event;
  const div = container.firstChild;
  div.setAttribute("id", key);

  let dDate = div.querySelector(".dDate");
  let dTime = div.querySelector(".dTime");
  let dArrive = div.querySelector(".dArrive");
  let spArrive = div.querySelector(".dArrive span");
  let dType = div.querySelector(".dType");
  let dLocation = div.querySelector(".dLocation");
  let aLocation = div.querySelector(".aLoc");
  let dNotes = div.querySelector(".dNotes");
  let btnRsvp = div.querySelector(".btnRsvp");

  let start = formatTime(event.start);
  dDate.innerHTML = formatDate(event.start, false);
  let end = event.end ? formatTime(event.end) : null;
  if (end) {
    dTime.textContent = `${start} - ${end}`;
  } else {
    dTime.textContent = start;
  }
  if (event.arrive != 0) {
    setDisplay(dArrive, "block");
    spArrive.textContent = formatTime(event.arrive);
  } else {
    setDisplay(dArrive, "none");
  }

  dType.textContent = event.type;

  if (event.loc) {
    aLocation.innerHTML = event.loc;
    aLocation.href = getMapLink(event.loc);
    setDisplay(dLocation, "-webkit-box");
  } else {
    setDisplay(dLocation, "none");
  }

  if (event.notes) {
    dNotes.textContent = event.notes;
    setDisplay(dNotes, "block");
  } else {
    setDisplay(dNotes, "none");
  }

  $(btnRsvp).off("click");
  $(btnRsvp).on("click", function () {
    initRsvpModal(key, event);
  });

  if (dOld) {
    parent.replaceChild(div, dOld);
  } else {
    parent.appendChild(div);
  }
}

function initRsvpModal(key, event) {
  setDisplay(dRsvp, "flex");
  activeEvent = key;
  let btnEdit = dRsvp.querySelector(".btn-rs-edit");
  let rsDate = dRsvp.querySelector(".rs-date");
  let rsType = dRsvp.querySelector(".rs-type");
  let spArrive = dRsvp.querySelector(".sp-arrive");
  let rsArrive = dRsvp.querySelector(".rs-arrive");
  let rsTime = dRsvp.querySelector(".rs-time");
  let aLoc = dRsvp.querySelector(".rs-loc");
  let spLoc = dRsvp.querySelector(".rs-loc span");
  let rsNotes = dRsvp.querySelector(".rs-notes");
  let rbUserYes = document.getElementById("radYes");
  let rbUserNo = document.getElementById("radNo");
  let rbUserMaybe = document.getElementById("radMaybe");
  let rsStaffYesCount = dRsvp.querySelector(".rs-staff-yes span");
  let rsStaffNoCount = dRsvp.querySelector(".rs-staff-no span");
  let rsPlayerYesCount = dRsvp.querySelector(".rs-player-yes span");
  let rsPlayerNoCount = dRsvp.querySelector(".rs-player-no span");

  //let rgGoing = dRsvp.querySelectorAll('#dRsvpStaff input[name="rsvp"]');

  $(btnEdit).off("click");
  $(btnEdit).on("click", function () {
    //TODO: show edit rsvp modal
  });

  rsDate.innerHTML = formatDate(event.start, true);
  rsType.textContent = event.type;
  if (event.arrive != 0) {
    setDisplay(rsArrive, "block");
    spArrive.textContent = formatTime(event.arrive);
  } else {
    setDisplay(rsArrive, "none");
  }

  let start = formatTime(event.start);
  let end = event.end ? formatTime(event.end) : null;
  if (end) {
    rsTime.textContent = `${start} - ${end}`;
  } else {
    rsTime.textContent = start;
  }

  if (event.loc) {
    spLoc.innerHTML = event.loc;
    aLoc.href = getMapLink(event.loc);
    setDisplay(aLoc, "block");
  } else {
    setDisplay(aLoc, "none");
  }

  if (event.notes) {
    rsNotes.textContent = event.notes;
    setDisplay(rsNotes, "block");
  } else {
    setDisplay(rsNotes, "none");
  }

  if (dbPlayers == null) {
    loadPlayers(key);
  } else {
    for (let index = 0; index < playerKeyList.length; index++) {
      const playerId = playerKeyList[index];
      getPlayerRsvp(playerId, key);
    }
  }

  //User rsvp listeners
  $(rbUserYes).off("click");
  $(rbUserNo).off("click");
  $(rbUserMaybe).off("click");

  let rgGoing = [];
  rgGoing.push(rbUserYes);
  rgGoing.push(rbUserNo);
  rgGoing.push(rbUserMaybe);

  if (user) {
    dbURsvp = ref(db, `uRsvp/${key}/${user.uid}`);
    onValue(dbURsvp, (data) => {
      if (data.exists()) {
        let going = data.val();
        if (going) {
          rbUserYes.checked = true;
        } else {
          rbUserNo.checked = true;
        }
      } else {
        rbUserMaybe.checked = true;
      }
    });

    dbUserGoingCount = ref(db, `userRsvpCount/${key}`);
    onValue(dbUserGoingCount, (data) => {
      let rsvp = null;
      if (data.exists()) {
        rsvp = data.val();
      }

      rsStaffYesCount.textContent = rsvp != null ? rsvp.yes : "0";
      rsStaffNoCount.textContent = rsvp != null ? rsvp.no : "0";
    });

    dbPlayerGoingCount = ref(db, `playerRsvpCount/${key}`);
    onValue(dbPlayerGoingCount, (data) => {
      let rsvp = null;
      if (data.exists()) {
        rsvp = data.val();
      }

      rsPlayerYesCount.textContent = rsvp != null ? rsvp.yes : "0";
      rsPlayerNoCount.textContent = rsvp != null ? rsvp.no : "0";
    });
  }

  for (let index = 0; index < rgGoing.length; index++) {
    const rb = rgGoing[index];
    rb.addEventListener("change", function (event) {
      let checked = event.target.value;
      if (checked && event.isTrusted) {
        if (user && role.member) {
          rsvp(user.uid, checked, false);
        } else {
          rbUserMaybe.checked = true;
          if (!user) {
            confirmLoginModal("Register or login to RSVP", `?g=${group.name}`);
          } else {
            showConfirmModal(
              "Join group",
              "You are not a part of this group yet. Would you like to join this group?",
              joinGroup
            );
          }
        }
      }
    });
  }
}

function joinGroup() {
  const dbMembers = ref(db, `members/${groupId}`);
  if (dbJoined == null) {
    dbJoined = ref(db, `joined/${user.uid}/${groupId}`);
  }
  const date = new Date().getTime();
  set(child(dbRole, `member`), true)
    .then(() => {
      set(child(dbMembers, user.uid), date).then(() => {
        set(dbJoined, date).then(() => {
          showToast("success", "Joined successfully!");
        });
      });
    })
    .catch((e) => {
      showToast("error", "Could not join group");
    });
}
function loadPlayers(eventId) {
  if (dbPlayers) {
    off(dbPlayers);
  }
  teamId = group.team != null ? group.team : groupId;
  dbPlayers = ref(db, `players/${teamId}`);

  onChildAdded(dbPlayers, (data) => {
    getPlayerInfo(data.key, eventId);
  });
}

function getPlayerInfo(key, eventId) {
  let rsvpNoPlayers = document.getElementById("rsvpNoPlayers");
  if (dbPlayer == null) {
    dbPlayer = ref(db, `player`);
  }

  onValue(
    child(dbPlayer, `${key}`),
    (data) => {
      let player;
      if (data.exists()) {
        player = data.val();
        if (player) {
          playerKeyList.push(key);
          addPlayer(key, player, dPlayerList);
          addPlayerRsvp(key, player, dRsvpPlayerList, eventId);
          if (currentPerson == 0) {
            setDisplay(dNoPeople, "none");
          }
          setDisplay(rsvpNoPlayers, "none");
        }
      }
    },
    { onlyOnce: true }
  );
}

function addPlayer(key, player, parent) {
  var dOld = document.getElementById(key);
  const container = document.createElement("div");
  container.innerHTML = list_player;
  const div = container.firstChild;
  div.setAttribute("id", key);

  let btnEdit = div.querySelector(".btn-edit");
  let imgPlayer = div.querySelector(".img-player");
  let btnRemove = div.querySelector(".btn-remove");
  let dName = div.querySelector(".dName");
  let dNum = div.querySelector(".dNum");
  let dPos = div.querySelector(".dPos");

  if (!role.owner) {
    setDisplay(btnEdit, "none");
    setDisplay(btnRemove, "none");
  }

  $(imgPlayer).on("error", function () {
    imgPlayer.src = phUser;
  });
  $(btnEdit).off("click");
  $(btnRemove).off("click");

  $(btnEdit).on("click", function () {
    //TODO: edip player modal
  });

  $(btnEdit).on("click", function () {
    //TODO: confirm remove player
  });

  imgPlayer.src = player.imgUrl ? player.imgUrl : phUser;
  dName.textContent = player.name;
  dNum.textContent = player.num;
  dPos.textContent = getPlayerPos(player.pos);

  if (dOld) {
    parent.replaceChild(div, dOld);
  } else {
    parent.appendChild(div);
  }
}

function addPlayerRsvp(key, player, parent, eventId) {
  let eId = `${key}Rsvp`;
  var dOld = document.getElementById(eId);
  const container = document.createElement("div");
  container.innerHTML = list_rsvp;
  const div = container.firstChild;
  div.setAttribute("id", eId);

  let imgPlayer = div.querySelector(".img-player");
  let dName = div.querySelector(".name");
  let rgRsvp = div.querySelectorAll('input[name="rsvp"]');
  let lblList = div.querySelectorAll("label");
  let rbIdList = [`rbYes${key}`, `rbNo${key}`, `rbMaybe${key}`];

  $(imgPlayer).on("error", function () {
    imgPlayer.src = phUser;
  });

  imgPlayer.src = player.imgUrl ? player.imgUrl : phUser;
  dName.textContent = player.name;

  for (let index = 0; index < rgRsvp.length; index++) {
    const rbGoing = rgRsvp[index];
    rbGoing.name = key;
    rbGoing.id = rbIdList[index];
    lblList[index].htmlFor = rbIdList[index];

    rbGoing.addEventListener("change", function (event) {
      let checked = event.target.value;
      if (checked && event.isTrusted) {
        if (user && role.member) {
          rsvp(key, checked, true);
        } else {
          rgRsvp[2].checked = true;
          if (!user) {
            confirmLoginModal("Register or login to RSVP", `?g=${group.name}`);
          } else {
            showConfirmModal(
              "Join group",
              "You are not a part of this group yet. Would you like to join this group?",
              joinGroup
            );
          }
        }
      }
    });
  }

  if (dOld) {
    parent.replaceChild(div, dOld);
  } else {
    parent.appendChild(div);
    if (eventId) {
      getPlayerRsvp(key, eventId);
    }
  }
}

function rsvp(uid, isGoing, isPlayer) {
  if (activeEvent == null) {
    return;
  }

  let path = isPlayer
    ? `pRsvp/${activeEvent}/${uid}`
    : `uRsvp/${activeEvent}/${uid}`;
  let dbRsvp = ref(db, path);

  if (isGoing == "maybe") {
    remove(dbRsvp)
      .then(() => {
        showToast("success", "RSVP removed");
      })
      .catch((e) => {
        showToast("error", "Something went wrong. Try again later.");
      });
  } else {
    let val = isGoing == "yes";
    set(dbRsvp, val)
      .then(() => {
        showToast("success", "RSVP updated!");
      })
      .catch((e) => {
        showToast("error", "Something went wrong. Try again later.");
      });
  }
}

function getPlayerRsvp(key, eventId) {
  let rbYes = document.getElementById(`rbYes${key}`);
  if (!rbYes) {
    return;
  }
  let rbNo = document.getElementById(`rbNo${key}`);
  let rbMaybe = document.getElementById(`rbMaybe${key}`);

  if (dbPRsvp == null) {
    dbPRsvp = ref(db, `pRsvp/${eventId}`);
  }

  onValue(child(dbPRsvp, `${key}`), (data) => {
    if (playerKeyList.includes(key)) {
      let n = 2; // maybe
      if (data.exists()) {
        let going = data.val();
        if (going != null) {
          n = going ? 1 : 0;
        }
      }
      switch (n) {
        case 0:
          rbNo.checked = true;
          break;
        case 1:
          rbYes.checked = true;
          break;
        default:
          rbMaybe.checked = true;
          break;
      }
    } else {
      off(child(dbPRsvp, `${key}`));
    }
  });
}

function initTeamFrag() {
  dbTeam = ref(db, `team`);
  dNoPeople = document.getElementById("dNoPeople");
  let btnAddPerson = document.getElementById("btnAddPerson");
  let rgPeople = document.querySelectorAll(
    '#dTeamOptions input[name="people"]'
  );
  let peopleList = document.querySelectorAll(".t-people");
  let btnNameList = ["Add player", "Add staff", "Invite member"];
  initPlayerFrag();
  for (let index = 0; index < rgPeople.length; index++) {
    const rb = rgPeople[index];
    rb.addEventListener("change", function (event) {
      let checked = event.target.value;
      if (checked) {
        peopleList[index].classList.add("selected");
        peopleList[currentPerson].classList.remove("selected");
        btnAddPerson.querySelector("span").textContent = btnNameList[index];
        currentPerson = index;
        //TODO: init person frag
        // loadPlayers()
        initPeopleFrags(checked);
      }
    });
  }
  $(btnAddPerson).click(function () {
    addRole();
  });
}

function initPeopleFrags(type) {
  switch (type) {
    case "players":
      initPlayerFrag();
      break;
    case "staff":
      initStaffFrag();
      break;
    default: //members
      initMemberFrag();
      break;
  }
}

function initPlayerFrag() {
  setDisplay(dNoPeople, dPlayerList.children.length == 0 ? "flex" : "none");

  dNoPeople.querySelector("p").textContent = user
    ? "No players yet"
    : "Login to view this information";

  if (user && dbPlayers == null) {
    loadPlayers();
  }
}

function initStaffFrag() {
  setDisplay(dNoPeople, dStaffList.children.length == 0 ? "flex" : "none");

  dNoPeople.querySelector("p").textContent = user
    ? "No staff yet"
    : "Login to view this information";

  if (!user || dbStaff) {
    return;
  }

  dbStaff = ref(db, `staff/${groupId}`);
  onChildAdded(dbStaff, (data) => {
    getPersonInfo("staff", data.key, dStaffList);
  });

  onChildRemoved(dbStaff, (data) => {
    removeElement(`staff${data.key}`);
    if (currentPerson == 1 && dStaffList.children.length == 0) {
      setDisplay(dNoPeople, "flex");
    }
  });
}

function initMemberFrag() {
  setDisplay(dNoPeople, dMemberList.children.length == 0 ? "flex" : "none");

  dNoPeople.querySelector("p").textContent = user
    ? "No members yet"
    : "Login to view this information";

  if (!user || dbMembers) {
    return;
  }

  dbMembers = ref(db, `members/${groupId}`);
  onChildAdded(dbMembers, (data) => {
    getPersonInfo("member", data.key, dMemberList);
  });

  onChildRemoved(dbMembers, (data) => {
    removeElement(`member${data.key}`);
    if (currentPerson == 2 && dMemberList.children.length == 0) {
      setDisplay(dNoPeople, "flex");
    }
  });
}

function getPersonInfo(type, key, parent) {
  let dbUser = ref(db, `user/${key}`);
  onValue(
    dbUser,
    (data) => {
      let user = null;
      if (data.exists()) {
        user = data.val();
      }
      if (user) {
        addPerson(type, key, user, parent);
        if (
          (type == "staff" && currentPerson == 1) ||
          (type == "member" && currentPerson == 2)
        ) {
          setDisplay(dNoPeople, "none");
        }
      }
    },
    { onlyOnce: true }
  );
}

function addPerson(type, key, user, parent) {
  let id = type ? `type${key}` : key;
  var dOld = document.getElementById(id);
  const container = document.createElement("div");
  container.innerHTML = list_person;
  const div = container.firstChild;
  div.setAttribute("id", id);

  let imgUser = div.querySelector(".img-user");
  let dName = div.querySelector(".name");
  let btnMore = div.querySelector(".btnMore");

  $(imgUser).on("error", function () {
    imgUser.src = phUser;
  });
  $(btnMore).off("click");
  $(btnMore).on("click", function () {
    //TODO: show user options
    //view profile
  });

  imgUser.src = user.imgUrl ? user.imgUrl : phUser;
  dName.textContent = user.name;

  if (dOld) {
    parent.replaceChild(div, dOld);
  } else {
    parent.appendChild(div);
  }
}

function addRole() {
  //todo: player selector and member invite
  switch (currentPerson) {
    case 0: //Players
      break;
    case 1: //Staff
      break;
    default: //Members
      break;
  }
}

function initChatFrag() {
  if (!user || dbMsg) {
    return;
  }
  dbMsg = ref(db, `msg/${groupId}`);
  dbChat = ref(db, `chat/${groupId}`);
  dbUchat = ref(db, `uChat/${user.uid}/${groupId}`);

  onChildAdded(dbMsg, (data) => {
    setDisplay(dEmptyMsg, "none");
    addMsg(dMsgList, data.key, data.val());
  });
  onChildChanged(dbMsg, (data) => {
    addMsg(dMsgList, data.key, data.val());
  });

  onChildRemoved(dbMsg, (data) => {
    removeElement(data.key);
    if (dMsgList.children.length == 0) {
      setDisplay(dEmptyMsg, "block");
    }
  });

  btnSendMsg = document.getElementById("btnSendMsg");
  inMsg = document.getElementById("inMsg");
  $(btnSendMsg).off("click");
  $(btnSendMsg).on("click", function () {
    if (userInfo) {
      checkInput(inMsg.value.trim());
    } else {
      let msg = user
        ? "Finish setting up your profile to participate in the chat"
        : "Register or login to participate in the chat";
      confirmLoginModal(msg, `?g=${group.name}`);
    }
  });
  //TODO: init send messages
  // copy from index.js 408
  // and reference MsgFrag Android for extra Msg data to include
}

/**
 * Check if message input is empty or null
 * @param {*} s String input
 */
function checkInput(s) {
  if (s) {
    sendMsg(s);
  } else {
    shake(inMsg);
    //$(inMsg).shake();
  }
}

/**
 * Send a new message
 * @param {*} msg Text input
 */
function sendMsg(msg) {
  const key = push(dbMsg).key;
  if (key) {
    const data = {
      uid: user.uid,
      name: userInfo.name,
      img: userInfo.imgUrl ? userInfo.imgUrl : null,
      chan: groupId,
      key: key,
      type: `txt`,
      msg: msg,
      date: new Date().getTime(),
      chanImg: group.imgUrl ? group.imgUrl : null,
      chanName: group.name,
    };
    set(child(dbMsg, `${key}`), data)
      .then(() => {
        const recent = {
          date: data.date,
          img: group.imgUrl ? group.imgUrl : null,
          name: group.name,
          type: "group",
        };
        set(dbUchat, recent);
        inMsg.value = "";
        inMsg.focus();
      })
      .catch((e) => {
        console.log("====================================");
        console.log("could not send message: " + e);
        console.log("====================================");
        showToast("error", "Could not send message");
      });
  }
}

function addMsg(parent, key, msg) {
  var dOld = document.getElementById(key);
  const container = document.createElement("div");
  container.innerHTML = list_msg;
  const div = container.firstChild;
  div.setAttribute("id", key);

  let ivUser = div.querySelector("img");
  let dName = div.querySelector(".name");
  let ivImg = div.querySelector(".msg-content img");
  let dTxt = div.querySelector(".txt");
  let dDate = div.querySelector(".date");

  ivUser.src = msg.img ? msg.img : phUser;
  dName.textContent = msg.name;
  ivImg.src = msg.mediaUrl ? msg.mediaUrl : phImg;
  dTxt.textContent = msg.msg;
  dDate.textContent = formatTime(msg.date);

  if (dOld) {
    parent.replaceChild(div, dOld);
  } else {
    parent.appendChild(div);
  }
}
